import { create } from 'zustand';
import { regionsAPI, districtsAPI } from '../api/services';

const useRegionStore = create((set) => ({
  regions: [],
  districts: [],
  loading: false,
  error: null,

  fetchRegions: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await regionsAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        regions: Array.isArray(data) ? data : data?.data || [],
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchDistricts: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await districtsAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        districts: Array.isArray(data) ? data : data?.data || [],
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  createRegion: async (data) => {
    const res = await regionsAPI.create(data);
    return res.data;
  },

  updateRegion: async (id, data) => {
    const res = await regionsAPI.update(id, data);
    return res.data;
  },

  deleteRegion: async (id) => {
    await regionsAPI.delete(id);
  },

  createDistrict: async (data) => {
    const res = await districtsAPI.create(data);
    return res.data;
  },

  updateDistrict: async (id, data) => {
    const res = await districtsAPI.update(id, data);
    return res.data;
  },

  deleteDistrict: async (id) => {
    await districtsAPI.delete(id);
  },
}));

export default useRegionStore;
